var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGolfHole2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1244_4635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 17.998C24.0001 21.418 18.8411 23.998 12.0001 23.998C5.15912 23.998 0.00012207 21.418 0.00012207 17.998C0.00012207 15.372 2.99912 13.209 7.82512 12.353C8.37812 12.26 8.88812 12.62 8.98412 13.164C9.08112 13.707 8.71812 14.226 8.17412 14.323C4.59612 14.957 1.99912 16.502 1.99912 17.998C1.99912 19.89 6.10512 21.998 11.9991 21.998C17.8931 21.998 21.9991 19.89 21.9991 17.998C21.9991 16.502 19.4021 14.957 15.8241 14.323C15.2801 14.226 14.9181 13.707 15.0141 13.164C15.1101 12.62 15.6201 12.257 16.1731 12.353C20.9991 13.208 23.9981 15.371 23.9981 17.998H24.0001ZM11.0001 17.998V2.68996C11.0001 1.30296 11.7321 0.641962 12.1701 0.371962C12.8971 -0.0770378 13.8961 -0.125038 14.6571 0.254962C14.6961 0.273962 19.9581 3.81696 19.9581 3.81696C20.6871 4.35496 21.0601 5.17296 20.9921 6.03096C20.9261 6.88796 20.4301 7.63796 19.6691 8.03696L13.0001 11.308V17.997C13.0001 18.549 12.5531 18.997 12.0001 18.997C11.4471 18.997 11.0001 18.55 11.0001 17.998ZM13.0001 9.08096L18.7651 6.25296C18.9481 6.15696 18.9911 5.97496 18.9981 5.87596C19.0061 5.77596 18.9911 5.58796 18.8051 5.44996L13.7261 2.02796C13.6711 2.00896 13.5991 1.99696 13.5221 1.99696C13.4201 1.99696 13.3101 2.01796 13.2221 2.07296C13.0751 2.16396 13.0001 2.37096 13.0001 2.68996V9.08096Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1244_4635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.00012207 -0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfHole2);
export default __webpack_public_path__ + "static/media/golf-hole 2.d0f77be40e5e6a3be81c1b255f4674b6.svg";
export { ForwardRef as ReactComponent };